const getIconSize = (icon) => {
  switch (icon) {
    case "brackets.svg":
      return "160%";
    case "backsplash.svg":
    case "cabinets.svg":
      return "150%";
    case "dishwasher-strip.svg":
      return "130%";
    case "cutouts.svg":
      return "120%";
    case "bathtub-new.svg":
    case "bathtub-fixture.svg":
    case "ceiling.svg":
    case "countertop.svg":
    case "large_corner_seat.svg":
      return "100%";
    case "center-island-countertop.svg":
    case "vanity-handle.svg":
    case "anti_slip.svg":
    case "showerbase.svg":
    case "solid_surface_base.svg":
      return "90%";
    case "slabs.svg":
    case "tiles.svg":
    case "towel_bar.svg":
      return "85%";
    case "bathtub-liner.svg":
    case "mirror-new.svg":
    case "mosaics.svg":
    case "pony-wall-cap.svg":
    case "shower-fixture.svg":
    case "shower-wall.svg":
    case "window-covering.svg":
    case "toilet_paper_holder.svg":
    case "accesories.svg":
    case "corner_caddie.svg":
      return "80%";
    case "backsplash-new.svg":
    case "dishwasher.svg":
    case "material.svg":
    case "shower-tub-combo.svg":
    case "vanity-cabinet.svg":
    case "walls.svg":
    case "walls-new.svg":
    case "window.svg":
    case "robe_hooks.svg":
    case "soap_dish.svg":
    case "storage.svg":
      return "70%";
    case "chair.svg":
    case "pattern.svg":
    case "wood.svg":
    case "wood-new.svg":
    case "wood-new-2.svg":
    case "beadboard.svg":
    case "caulk.svg":
    case "curtain_rod.svg":
    case "fasteners.svg":
    case "literature.svg":
    case "overflow.svg":
    case "sales_kit.svg":
    case "signage.svg":
    case "towel_ring.svg":
    case "valves.svg":
    case "large_corner_caddie.svg":
      return "60%";
    case "bottom-cabinet.svg":
    case "mirror.svg":
    case "shower-tub.svg":
      return "55%";
    case "pony-wall.svg":
    case "pony-wall-glass.svg":
    case "shower.svg":
    case "shower-door.svg":
      return "50%";
    case "toilet.svg":
    case "top-cabinet.svg":
      return "40%";
    case "custom-icon-desktop.svg":
      return "50%";
    case "bathtub.svg":
      return {
        backgroundSize: "100%",
        backgroundPosition: "top 39% center"
      };
    case "crown-molding.svg":
      return {
        backgroundSize: "100%",
        backgroundPosition: "top 25% center"
      };
    case "faucets-new.svg":
      return {
        backgroundSize: "85%",
        backgroundPosition: "top 40% center"
      };
    case "jetted-tub.svg":
      return {
        backgroundSize: "85%",
        backgroundPosition: "top 65% center"
      };
    case "replacement-tub.svg":
      return {
        backgroundSize: "80%",
        backgroundPosition: "top 60% center"
      };
    case "shower-door-handle.svg":
      return {
        backgroundSize: "60%",
        backgroundPosition: "top 38% center"
      };
    case "shower-pan.svg":
      return {
        backgroundSize: "100%",
        backgroundPosition: "top 40% center"
      };
    case "shower-wall-accent.svg":
      return {
        backgroundSize: "70%",
        backgroundPosition: "top center"
      };
    case "toilet-new.svg":
      return {
        backgroundSize: "80%",
        backgroundPosition: "top 38% center"
      };
    case "walk-in-tub.svg":
      return {
        backgroundSize: "80%",
        backgroundPosition: "top 60% center"
      };
    case "cabinet_leg.svg":
      return {
        backgroundSize: "17%",
      };
    case "garage-hook.svg":
    case "slat_wall.svg":
      return {
        backgroundSize: "45%",
      };
    case "overhead_rack.svg":
      return {
        backgroundSize: "65%",
      };
    default:
      return null // don't change CSS property
  }
};

export const getIconStyles = (image) => {
  let baseStyles = {
    backgroundImage: `url(https://quotekitchenandbath.com/content/views/dashboard/images/icons/pj-scope-icons/enabled/${image})`
  };
  const styles = getIconSize(image);
  if (styles) {
    if (typeof styles === "string") {
      baseStyles.backgroundSize = styles
    } else {
      baseStyles = {
        ...baseStyles,
        ...styles
      }
    }
  }
  return baseStyles
};

export const getCategoryIconStyles = (bgImageUrl) => {
  let baseStyles = {
    backgroundImage: `url(http://quotesflooring.com/${bgImageUrl})`
  };
  const styles = getCategoryIconSize(bgImageUrl);
  if (styles) {
    if (typeof styles === "string") {
      baseStyles.backgroundSize = styles
    } else {
      baseStyles = {
        ...baseStyles,
        ...styles
      }
    }
  }
  return baseStyles
};

const getCategoryIconSize = (bgImageUrl) => {
  const icon = bgImageUrl.split("enabled/")[1];
  switch (icon) {
    case "anti_slip.svg":
      return {
        backgroundSize: "50%",
        backgroundPosition: "top 30% center"
      };
    case "backsplash-new.svg":
    case "beadboard.svg":
    case "caulk.svg":
    case "curtain_rod.svg":
    case "fasteners.svg":
    case "literature.svg":
    case "robe_hooks.svg":
    case "sales_kit.svg":
    case "signage.svg":
    case "soap_dish.svg":
    case "storage.svg":
    case "slabs.svg":
    case "tiles.svg":
    case "towel_ring.svg":
    case "valves.svg":
      return "contain";
    case "bathtub.svg":
      return {
        backgroundSize: "52%",
        backgroundPosition: "top 27% center"
      };
    case "bathtub-new.svg":
      return {
        backgroundSize: "50%",
        backgroundPosition: "top 23% center"
      };
    case "bathtub-fixture.svg":
      return {
        backgroundSize: "50%",
        backgroundPosition: "top 32% center"
      };
    case "bathtub-liner.svg":
    case "jetted-tub.svg":
      return {
        backgroundSize: "44%",
        backgroundPosition: "top 30% center"
      };
    case "bottom-cabinet.svg":
      return {
        backgroundSize: "30%",
        backgroundPosition: "top 22% center"
      };
    case "brackets.svg":
    case "cabinets.svg":
      return "90%";
    case "ceiling.svg":
      return {
        backgroundSize: "64%",
        backgroundPosition: "top 34% center"
      };
    case "center-island-countertop.svg":
      return {
        backgroundSize: "54%",
        backgroundPosition: "top 16% center"
      };
    case "chair.svg":
      return "32%";
    case "countertop.svg":
      return {
        backgroundSize: "60%",
        backgroundPosition: "top 33% center"
      };
    case "crown-molding.svg":
      return {
        backgroundSize: "54%",
        backgroundPosition: "top 5% center"
      };
    case "cutouts.svg":
      return {
        backgroundSize: "70%",
        backgroundPosition: "top 130% center"
      };
    case "dishwasher.svg":
      return {
        backgroundSize: "33%",
        backgroundPosition: "top -7% center"
      };
    case "dishwasher-strip.svg":
      return {
        backgroundSize: "80%",
        backgroundPosition: "top 20px center"
      };
    case "faucets-new.svg":
      return {
        backgroundSize: "40%",
        backgroundPosition: "top 22% center"
      };
    case "large_corner_seat.svg":
      return {
        backgroundSize: "65%",
        backgroundPosition: "top 35% center"
      };
    case "material.svg":
      return {
        backgroundSize: "36%",
        backgroundPosition: "top 6px center"
      };
    case "mirror.svg":
      return {
        backgroundSize: "26%",
        backgroundPosition: "top -10% center"
      };
    case "mirror-new.svg":
      return "36%";
    case "mosaics.svg":
      return "46%";
    case "overflow.svg":
      return "32%";
    case "pattern.svg":
      return {
        backgroundSize: "30%",
        backgroundPosition: "top 15px center"
      };
    case "pony-wall.svg":
    case "pony-wall-glass.svg":
      return {
        backgroundSize: "24%",
        backgroundPosition: "top 8px center"
      };
    case "pony-wall-cap.svg":
      return {
        backgroundSize: "33%",
        backgroundPosition: "top 8px center"
      };
    case "replacement-tub.svg":
      return {
        backgroundSize: "50%",
        backgroundPosition: "top 54% center"
      };
    case "shower.svg":
    case "showerbase.svg":
    case "solid_surface_base.svg":
    case "toilet_paper_holder.svg":
      return {
        backgroundSize: "54%",
        backgroundPosition: "top 30% center"
      };
    case "shower-door.svg":
      return {
        backgroundSize: "28%",
        backgroundPosition: "top 20% center"
      };
    case "shower-door-handle.svg":
      return {
        backgroundSize: "30%",
        backgroundPosition: "top 10% center"
      };
    case "shower-fixture.svg":
      return {
        backgroundSize: "44%",
        backgroundPosition: "top 10% center"
      };
    case "shower-pan.svg":
      return {
        backgroundSize: "60%",
        backgroundPosition: "top 32% center"
      };
    case "shower-tub.svg":
      return {
        backgroundSize: "28%",
        backgroundPosition: "top 20% center"
      };
    case "shower-tub-combo.svg":
      return {
        backgroundSize: "38%",
        backgroundPosition: "top 20% center"
      };
    case "shower-wall.svg":
      return {
        backgroundSize: "40%",
        backgroundPosition: "top 10% center"
      };
    case "shower-wall-accent.svg":
      return "40%";
    case "toilet-new.svg":
      return {
        backgroundSize: "40%",
        backgroundPosition: "top center"
      };
    case "towel_bar.svg":
      return {
        backgroundSize: "48%",
        backgroundPosition: "top 20% center"
      };
    case "toilet.svg":
      return {
        backgroundSize: "20%",
        backgroundPosition: "top 20px center"
      };
    case "top-cabinet.svg":
      return {
        backgroundSize: "20%",
        backgroundPosition: "top 80% center"
      };
    case "vanity-cabinet.svg":
      return {
        backgroundSize: "36%",
        backgroundPosition: "top -38% center"
      };
    case "vanity-handle.svg":
      return {
        backgroundSize: "44%",
        backgroundPosition: "top 20% center"
      };
    case "walk-in-tub.svg":
      return {
        backgroundSize: "40%",
        backgroundPosition: "top 50% center"
      };
    case "walls.svg":
      return {
        backgroundSize: "32%",
        backgroundPosition: "top 10px center"
      };
    case "walls-new.svg":
      return {
        backgroundSize: "34%",
        backgroundPosition: "top 38% center"
      };
    case "window.svg":
      return {
        backgroundSize: "30%",
        backgroundPosition: "top 30% center"
      };
    case "window-covering.svg":
      return {
        backgroundSize: "40%",
        backgroundPosition: "top center"
      };
    case "wood.svg":
    case "wood-new.svg":
      return {
        backgroundSize: "32%",
        backgroundPosition: "top 93% center"
      };
    case "wood-new-2.svg":
      return {
        backgroundSize: "32%",
        backgroundPosition: "top 100% center"
      };
    default:
      return null // don't change CSS property
  }
};
